function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 575 575",
    className: "roots-wrapper",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.1,362.2c24.2-33.9,38.5-75.4,38.5-120.2c0-114.2-92.6-206.8-206.8-206.8C111.6,35.2,19,127.8,19,242   c0,114.2,92.6,206.8,206.8,206.8c44.9,0,86.5-14.3,120.5-38.7l-55.3-65.6c-18.8,12-41.2,18.9-65.2,18.9   c-67.1,0-121.5-54.4-121.5-121.5c0-67.1,54.4-121.5,121.5-121.5c67.1,0,121.5,54.4,121.5,121.5c0,18.3-4.1,35.7-11.3,51.3   L394.1,362.2z",
    className: "st0",
    style: {
      fill: "rgb(250, 250, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.2,439.2c18.2-13.4,34.5-29.4,48.3-47.2l0,0l61.4,72.8h-88.2L371.2,439.2L371.2,439.2z",
    className: "st0",
    style: {
      fill: "rgb(250, 250, 250)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logoSvg.3c5020609b763ffbf39b7dbc75ea7821.svg";
export { ForwardRef as ReactComponent };